import React, { ReactNode } from 'react';
import styles from './styles.module.scss';
import { useMediaQuery } from 'react-responsive';

interface I_ResultNoDataProps {
    onLinkClick?: () => void;
    icon: ReactNode;
    content: string;
    linkText: string;
}

const ResultNoData = (props: I_ResultNoDataProps) => {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    const { icon, content, linkText, onLinkClick } = props;

    return (
        <div className={styles.noResultWrap}>
            {icon}
            <div className={`${styles.title} ${isMobile && styles.mContent}`}>{content}</div>
            <div className={styles.search} onClick={onLinkClick}>
                {linkText}
            </div>
        </div>
    );
};

export default ResultNoData;
